import { CheckoutConfirmationConfig } from "@ui/context/component-config-context";

const checkoutConfirmationConfig: CheckoutConfirmationConfig = {
  titleRecurring: "",
  titleOneTime: "",
  descriptionRecurring: "",
  descriptionOneTime: "",
  includeCaptcha: true,
  screens: ["newsletters", "podcasts", "customBrandScreen"],
  newsletters: {
    title: "You made it",
    description:
      "You've been opted into all subscriber-exclusive newsletters. Manage your email preferences anytime in <a href='/account/newsletters' target='_blank'>your account.</a>",
    items: [
      {
        imageUrl: "/static-assets/newsletters/notepad.png",
        title: "Notepad",
        description:
          "A weekly window into Microsoft's era-defining bets on AI, gaming, and the future of computing by Tom Warren.",
      },
      {
        imageUrl: "/static-assets/newsletters/thestepback.png",
        title: "The Stepback",
        description:
          "A weekly newsletter delivering the deeper story behind The Verge's biggest beats.",
      },
      {
        imageUrl: "/static-assets/newsletters/optimizer.png",
        title: "Optimizer",
        description:
          "A weekly quest to live a smarter, healthier digital life.",
      },
      {
        imageUrl: "/static-assets/newsletters/installer.png",
        title: "Installer",
        description:
          "A weekly newsletter designed to tell you everything you need to download, watch, read, listen to, and explore that fits in The Verge's universe.",
      },
    ],
  },
  podcasts: {
    title: "Set up your ad-free podcasts",
    description:
      "To do this later, visit <a href='/account/podcasts' target='_blank'>your account</a> anytime.",
  },
  customBrandScreen: {
    useCustomScreenComponent: true,
  },
};

export default checkoutConfirmationConfig;
